module.exports = __webpack_public_path__ + "img/thumbnail_BoaConstrictor_u_albino.7992073f.png";